<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :disabled="disabled ? true : null" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _, { cloneDeep } from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import warehouse from '~/views/sale/warehouse/warehouse.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {}
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						excludeWarehouseIds: [],
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						selectorWidth: 'auto',
						buttons: [{
							title: this.$t('manage-items'),
							shortcut: $sc.find('enter'),
							element: () => { return this.$el },
							isPrimary: true,
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showWarehouses()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'warehouses/all'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)
					this.localValue = val
				}
			},
			dropdownData() {
				var warehouses = cloneDeep(this.all)

				if (this.settings.excludeWarehouseIds && this.settings.excludeWarehouseIds.length > 0)
					warehouses = warehouses.filter(x => !this.settings.excludeWarehouseIds.includes(x.id))

				return warehouses
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshWarehouses()
		},
		methods: {
			...mapActions({
				refreshWarehouses: 'warehouses/refresh'
			}),
			showWarehouses() {
				this.showModal({ component: warehouse, data: null, options: { type: this.settings.type, selectable: true, modelValue: this.dropdownValue } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
